var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-upload",
    {
      ref: "upload",
      class: {
        "has-active": _vm.hasDragged,
        "has-upload-wrapper": _vm.hasUploadFile
      },
      attrs: {
        drag: "",
        id: _vm.id,
        "before-upload": _vm.beforeUpload,
        action: "default",
        disabled:
          _vm.status === "pending" ||
          _vm.status === "approved" ||
          _vm.changeObj.show === "approve",
        "http-request": _vm.upload,
        headers: _vm.uploadHeaders,
        "show-file-list": false,
        "list-type": _vm.type === "img" ? "picture" : "text",
        "file-list": _vm.fileList,
        "before-remove": _vm.remove,
        "on-success": _vm.handleAvatarSuccess,
        "on-error": _vm.uploadError
      }
    },
    [
      !_vm.hasUploadFile
        ? _c("div", { staticClass: "upload-controller" }, [
            _c("img", {
              staticClass: "icon",
              attrs: { src: _vm.icon, alt: "icon" }
            }),
            _vm._v(" "),
            _c("div", { staticClass: "slot-upload" }, [
              _vm._v(
                "拖拽" +
                  _vm._s(_vm._f("fomateTypeToUpcase")(_vm.type)) +
                  " 到这里或"
              ),
              _c(
                "span",
                {
                  staticClass: "upload-txt",
                  attrs: { slot: "trigger" },
                  slot: "trigger"
                },
                [_vm._v("选择文件")]
              )
            ])
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.hasUploadFile
        ? _c("div", { staticClass: "has-upload" }, [
            _c("img", {
              staticClass: "icon",
              attrs: { src: _vm.activeIcon, alt: "icon" }
            }),
            _vm._v(" "),
            _vm.changeObj && _vm.changeObj.show
              ? _c(
                  "span",
                  {
                    style: {
                      color:
                        _vm.changeObj.show === "reject" ? "#F04037" : "#68BF7B"
                    }
                  },
                  [_vm._v(_vm._s(_vm.changeObj.txt))]
                )
              : _vm._e(),
            _vm._v(" "),
            _c("span", { staticClass: "content-flex-1" }, [
              _vm._v(_vm._s(_vm.name))
            ]),
            _vm._v(" "),
            _vm.deleteable
              ? _c(
                  "span",
                  {
                    staticClass: "delete-text",
                    on: {
                      click: function($event) {
                        $event.stopPropagation()
                        return _vm.deleteHandler.apply(null, arguments)
                      }
                    }
                  },
                  [_vm._v("删除")]
                )
              : _vm._e(),
            _vm._v(" "),
            _vm.couldDownload
              ? _c(
                  "span",
                  {
                    staticClass: "delete-text",
                    on: {
                      click: function($event) {
                        $event.stopPropagation()
                        return _vm.downloadHandler.apply(null, arguments)
                      }
                    }
                  },
                  [_vm._v("下载")]
                )
              : _vm._e(),
            _vm._v(" "),
            _vm.couldPreview
              ? _c(
                  "span",
                  {
                    staticClass: "delete-text",
                    on: {
                      click: function($event) {
                        $event.stopPropagation()
                        return _vm.previewHandler.apply(null, arguments)
                      }
                    }
                  },
                  [_vm._v("在线预览")]
                )
              : _vm._e()
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm._t("default"),
      _vm._v(" "),
      _vm.uploading
        ? _c("div", { staticClass: "progress-control" }, [
            _c("div", { staticClass: "progress" }, [
              _c("div", {
                staticClass: "progress-inner",
                style: { width: _vm.progressPerset }
              })
            ]),
            _vm._v(" "),
            _c("i", {
              staticClass: "el-icon-close",
              on: {
                click: function($event) {
                  $event.stopPropagation()
                  return _vm.removeFile.apply(null, arguments)
                }
              }
            })
          ])
        : _vm._e()
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-728ba254", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-728ba254","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/upload-view/index.vue
// module id = null
// module chunks = 